import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import { useSelector } from "react-redux";
import { makeStyles } from '@mui/styles';
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
const useStyles = makeStyles({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "var(--primary)",
      height: 3,
    },
    "& .MuiTab-root": {
      color: "var(--text-secondary)",
      fontSize: "15px",
      fontWeight: "600",
      textTransform: "none",
      transition: "all 0.3s ease",
      fontFamily: 'Outfit, sans-serif'
    },
    "& .MuiTab-root.Mui-selected": {
      color: 'var(--primary)',
      textShadow: "0 0 10px rgba(233, 174, 49, 0.25)"
    }
  }
})

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AllReports() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', backgroundColor: 'var(--bg-main)' }}>
      <Box sx={{ borderBottom: '1px solid var(--border-color)', backgroundColor: 'var(--bg-card)' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className={classes.tabs} >
          {auth.profile.usertype === "fleetadmin" || auth.profile.usertype === "admin" ?
            <Tab style={{ marginRight: "20px" }} label={t('driver_earning')} {...a11yProps(0)} />
            : null}
          {auth.profile.usertype === "admin" ?
            <Tab style={{ marginRight: "20px" }} label={t('earning_reports')} {...a11yProps(1)} />
            : null}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <DriverEarning />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Earningreports />
      </TabPanel>
    </Box>
  );
}